import React from 'react';
import Icon from '../Icon';

const PressStrip = () => (
  <section className="press-strip" aria-hidden="false">
    <div className="container">
      <div className="press-label">As featured in caregiver communities &amp; state programs</div>
      <div className="marquee-mask">
        <div className="marquee-track">
          {[...Array(2)].map((_, i) => (
            <div key={i} className="marquee-row">
              <span className="press-item"><Icon name="shield" size={15} stroke={2.2}/> AARP Caregiver Network</span>
              <span className="press-item"><Icon name="heart" size={15} stroke={2.2}/> Family Caregiver Alliance</span>
              <span className="press-item"><Icon name="check-bold" size={14}/> Medicaid.gov referenced</span>
              <span className="press-item"><Icon name="sparkle" size={14} stroke={2.2}/> Veteran-Directed Care</span>
              <span className="press-item"><Icon name="sun" size={15} stroke={2.2}/> National Council on Aging</span>
              <span className="press-item"><Icon name="compass" size={15} stroke={2.2}/> IHSS California</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default PressStrip;
